module.exports = __webpack_public_path__ + "2f5f610270af0c1cebd4c2e7013913ff.jpg";